// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var ExternalOrderStatus;
(function (ExternalOrderStatus) {
    ExternalOrderStatus[ExternalOrderStatus["New"] = 0] = "New";
    ExternalOrderStatus[ExternalOrderStatus["Applied"] = 1] = "Applied";
    ExternalOrderStatus[ExternalOrderStatus["PartiallyFilled"] = 2] = "PartiallyFilled";
    ExternalOrderStatus[ExternalOrderStatus["Filled"] = 3] = "Filled";
    ExternalOrderStatus[ExternalOrderStatus["Rejected"] = 4] = "Rejected";
    ExternalOrderStatus[ExternalOrderStatus["Cancelled"] = 5] = "Cancelled";
    ExternalOrderStatus[ExternalOrderStatus["CancelingForModification"] = 6] = "CancelingForModification";
    ExternalOrderStatus[ExternalOrderStatus["PendingModification"] = 7] = "PendingModification";
    ExternalOrderStatus[ExternalOrderStatus["PendingCancel"] = 8] = "PendingCancel";
    ExternalOrderStatus[ExternalOrderStatus["Freeze"] = 9] = "Freeze";
    ExternalOrderStatus[ExternalOrderStatus["WaitingMarket"] = 10] = "WaitingMarket";
    ExternalOrderStatus[ExternalOrderStatus["Unplaced"] = 11] = "Unplaced";
    ExternalOrderStatus[ExternalOrderStatus["Suspended"] = 12] = "Suspended";
})(ExternalOrderStatus || (ExternalOrderStatus = {}));
